import { errorContent } from './errorUI';
import { isTenantFeatureEnabled } from '../helpers/tenantFeatureHelper';
import { arrowIconSVG } from '../icons/arrowIcon';

export const swipeIconsUIV2 = (): string => {
  const { title, subTitle, description, buttonTitle } = errorContent();

  const isArrowIcons = isTenantFeatureEnabled(['ARROW_ICONS']);

  const swipeRoundIconsSection = `
            <div id="swipe-icons" class="swipe-control ">
            <div class="swipe-control-wrapper shimmer-effect-swipe-sdk">
                <div id="swipe-icon-close" class="swipe-control__item sports">
                </div>
                <div id="swipe-icon-open" class="swipe-control__item"></div>
            </div>
            <span class="swipe-control__idle-chevron">
                <svg width="5" height="15" viewBox="0 0 5.93452 18.7095" fill="none">
                    <path d="M0.57928 0.296313L5.2047 9.32714L0.57928 18.4146" stroke="#FFF07E" stroke-width="1.5" fill="none"/>
                </svg>
            </span>
            ${arrowIconSVG()}
        </div>`;

  const swipeArrowIconsSection = `
            <div class="swipe-sdk-arraw-end"></div>
            <div id="swipe-icons" class="swipe-control __swipe-swipe-control-icons__">
                <div class="swipe-icons-bg-wrapper">
                    <div class="swipe-icons-bg-layer"></div>
                    <div class="swipe-icons-gradient-layer"></div>
                </div>
                <div class="swipe-close-icon-wrapper __swipe-swipe-hide__">
                    <div id="swipe-icon-close" class="swipe-control__item">
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M23.6766 7.79399C23.6427 7.73629 23.624 7.67088 23.6223 7.60395C21.2215 1.76963 14.7876 -1.29363 8.74481 0.520516C2.70199 2.33466 -0.980503 8.43501 0.229463 14.6269C1.43943 20.8187 7.14754 25.0842 13.4288 24.4903C19.7101 23.8965 24.5175 18.6367 24.5455 12.3279C24.5378 10.7759 24.2432 9.23881 23.6766 7.79399ZM11.3775 23.839C10.3374 23.7547 9.31398 23.5263 8.33671 23.1603C8.22811 23.106 8.09236 23.0788 7.98376 23.0245L8.01091 22.8616L9.50418 22.753L9.47702 21.0155L6.08323 17.4861L2.85235 16.7531L3.0424 19.2237C2.9338 19.0608 2.79804 18.8979 2.68944 18.735C1.42947 16.8359 0.758831 14.6069 0.76177 12.3279C0.76177 12.2464 0.788921 11.6491 0.788921 11.5677H0.897522L2.9881 7.60395L3.88406 4.42753C4.04696 4.26464 4.18271 4.10174 4.34561 3.93885C4.45421 3.8574 5.29588 3.12438 5.62168 2.88004L8.11951 1.79409L8.63536 1.5769L10.1286 0.979622C10.541 0.898687 10.9582 0.844278 11.3775 0.816729C11.6121 0.793601 11.8478 0.784535 12.0835 0.78958L12.1106 0.871027L9.04262 2.11987L10.4816 4.04744L15.5587 5.26914L18.0565 3.72166L16.4275 1.5769L16.4547 1.54975C16.6447 1.6312 16.8076 1.68549 16.9977 1.76694C17.1877 1.84839 17.4321 1.95698 17.6493 2.06558L18.8982 3.69451L22.292 7.44105L22.835 7.5225C22.8893 7.6311 22.9436 7.76684 22.9979 7.87544C23.0522 7.98403 23.0793 8.11978 23.1336 8.22837L22.3734 8.11978L21.6132 11.1062L22.4006 15.7486L23.2965 15.9929C23.2694 16.1015 23.2151 16.183 23.1879 16.2916C22.2904 18.7911 20.5536 20.902 18.2737 22.2643C18.1623 22.3465 18.0443 22.4191 17.9208 22.4815L18.3552 19.9295L14.3912 19.2508L10.1286 21.1241V22.9159L11.7305 23.6761L11.6762 23.8661C11.5759 23.8694 11.4756 23.8603 11.3775 23.839Z" fill="#353842"/>
                    <path d="M8.74481 0.520516C14.7876 -1.29363 21.2215 1.76963 23.6223 7.60395C23.624 7.67088 23.6427 7.73629 23.6766 7.79399C24.2432 9.23881 24.5378 10.7759 24.5455 12.3279C24.5175 18.6367 19.7101 23.8965 13.4288 24.4903C7.14754 25.0842 1.43943 20.8187 0.229463 14.6269C-0.980503 8.43501 2.70199 2.33466 8.74481 0.520516ZM12.0835 0.78958C11.8478 0.784535 11.6121 0.793601 11.3775 0.816729C10.9582 0.844278 10.541 0.898687 10.1286 0.979622L8.63536 1.5769L8.11951 1.79409L5.62168 2.88004C5.36104 3.07552 4.77025 3.58374 4.48875 3.82091L4.34561 3.93885L3.88406 4.42753L2.9881 7.60395L0.897522 11.5677H0.788921C0.788921 11.5948 0.785902 11.6793 0.781879 11.7829L0.768803 12.1127C0.764779 12.2162 0.76177 12.3007 0.76177 12.3279C0.758831 14.6069 1.42947 16.8359 2.68944 18.735L3.0424 19.2237L2.85235 16.7531L6.08323 17.4861L9.47702 21.0155L9.50418 22.753L8.01091 22.8616L7.98376 23.0245C8.09236 23.0788 8.22811 23.106 8.33671 23.1603C9.31398 23.5263 10.3374 23.7547 11.3775 23.839C11.4756 23.8603 11.5759 23.8694 11.6762 23.8661L11.7305 23.6761L10.1286 22.9159V21.1241L14.3912 19.2508L18.3552 19.9295L17.9208 22.4815C18.0443 22.4191 18.1623 22.3465 18.2737 22.2643C20.5536 20.902 22.2904 18.7911 23.1879 16.2916L23.2965 15.9929L22.4006 15.7486L21.6132 11.1062L22.3734 8.11978L23.1336 8.22837C23.0793 8.11978 23.0522 7.98403 22.9979 7.87544C22.9436 7.76684 22.8893 7.6311 22.835 7.5225L22.292 7.44105L18.8982 3.69451L17.6493 2.06558C17.4321 1.95698 17.1877 1.84839 16.9977 1.76694L16.4547 1.54975L16.4275 1.5769L18.0565 3.72166L15.5587 5.26914L10.4816 4.04744L9.04262 2.11987L12.1106 0.871027L12.0835 0.78958ZM17.4049 10.4274L21.0159 11.3233L21.8033 15.8572L18.5995 19.3051L14.6356 18.5992L13.984 14.2011L17.4049 10.4274ZM3.44965 8.06548L6.65339 8.25552L8.20096 13.1423L6.08323 16.8074L2.74374 16.0473L1.44053 11.9206L3.44965 8.06548ZM10.4273 4.67186L15.3958 5.83925L16.9162 10.0202L13.5224 13.7396L8.79827 12.898L7.27785 8.03832L10.4273 4.67186Z" fill="#353842"/>
                    </svg>

                    </div>
                    <span class="swipe-close-icon-label">Home</span>
                </div>
                <div id="swipe-icon-open" class="swipe-control__item __swipe-swipe-control-icon__ "></div>
            </div>`;

  const selectedIconSection = isArrowIcons
    ? swipeArrowIconsSection
    : swipeRoundIconsSection;

  const iconsUI = `
        <div style="width: 100vw; height: 100vh; display: flex; justify-content: center;
        align-items: center; background-color: #fff; color: #fff; font-size: 30px;
        position: fixed; top: 0; bottom: 0; z-index: 9999;" class="swipe-ctr spin-win">
            ${selectedIconSection}
             <div class="dropdown dropdown-rotation" style="z-index: 5; display: block; position: absolute;
            left: 10px; top: 10px; min-width: 180px; max-width: 180px;">
                <div class="dropdown__toggle spin-win" style="position: relative; width: 100%;
                height: 40px; border-radius: 20px; border: 2px solid #a8a8a8; background-color: #000;
                background-position: 0; background-repeat: no-repeat;"></div>
                <div class="dropdown__menu"></div>
            </div>
            <div class="swipe-sdk-overlay" style="width: 100vw; height: 100vh; z-index: 2; position: absolute;"></div>

            <div class="swipe_error_msg" style="display:none; width: 100vw; height: 100vh; z-index: 1;
            background: black; position: relative;">
                <div style="font-family: Arial, sans-serif; background-color: #343a40; color: #ffffff;
                border: 1px solid #495057; padding: 15px 0px; border-radius: 5px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                width: calc(100% - 30px); position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
                text-align: center;">
                    <h1 style="margin: 0 0 10px 0; font-size: 24px; color: #ffffff;">${title}</h1>
                    <p style="margin: 0 0 10px 0; font-size: 18px; color: #f8f9fa;">${subTitle}</p>
                    <p style="margin: 0; font-size: 16px; color: #adb5bd;">${description}</p>
                    <button onclick="location.reload()" style="background-color: #007bff; color: #ffffff;
                    border: none; padding: 10px 20px; border-radius: 5px; cursor: pointer; font-size: 16px;
                    margin-top: 15px;">${buttonTitle}</button>
                </div>
            </div>
            <div id="swipe-sdk__frame-container" class="swipe-sdk-loader">
             <div class="swipe-sdk-ribbon hide">Demo</div>

    <div class="sdk-drawer-menu" id="sdk-drawer-menu">
      <div class="sdk-drawer-menu__panel">
        <div class="sdk-drawer-menu__icons-row">
          <button class="sdk-drawer-menu__hamburger" id="sdk-drawer-menu-hamburger" aria-label="Open full game menu">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
              <line x1="3" y1="6" x2="21" y2="6"/>
              <line x1="3" y1="12" x2="21" y2="12"/>
              <line x1="3" y1="18" x2="21" y2="18"/>
            </svg>
          </button>
          <div class="scrollable-icons"></div>
        </div>
        <button class="sdk-drawer-menu__handle" id="sdk-drawer-menu-handle">
          <img class="sdk-drawer-menu__handle-icon" id="sdk-drawer-menu-handle-icon" alt="" />
          <span class="sdk-drawer-menu__handle-label" id="sdk-drawer-menu-handle-label" data-full-text="More Games"></span>
          <svg class="sdk-drawer-menu__chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </button>
      </div>
    </div>

    <div class="drawer-overlay"></div>

    <aside class="swipe-sdk-drawer" id="swipe-sdk-drawer">
        <div class="drawer-header">
            <button class="close-btn" id="close-drawer-btn">&times;</button>
            <div class="header-title">
                <h2>Casino Library</h2>
                <p id="swipe-game-counts-drawer"></p>
            </div>
        </div>
        <div class="drawer-content">
            <section class="game-section">
                <h3>All Games</h3>
                <div class="game-grid-drawer"></div>
            </section>
        </div>
    </aside>

<div id="loader__icon" class="loader__icon" style="position: absolute;
                top: 46%; left: 46%; transform: translate(-50%, -50%); text-align: center;"></div>
            </div>
        </div>
    `;

  return iconsUI;
};
